export interface IUpdateOrderCertificationWithAssetsOutputDto {
    urls: string[];
    failedAssets?: {
        filename: string;
        error: string;
    }[];
}
